import { Mail } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const MailIcon = DeckardIconWrapper({ Icon: Mail });
